import React from 'react';
type PlanDay = {
  day: string;
  action: string;
};
const planDays: PlanDay[] = [{
  day: 'Día 1',
  action: 'Eliges idea (te entregamos 30 ejemplos listos para inspirarte)'
}, {
  day: 'Día 2',
  action: 'Creas la estructura completa'
}, {
  day: 'Día 3',
  action: 'Expandes capítulos (sin escribir desde cero)'
}, {
  day: 'Día 4',
  action: 'Preparas tu prompt para Gamma'
}, {
  day: 'Día 5',
  action: 'Generas tu PDF y lo descargas'
}, {
  day: 'Día 6',
  action: 'Armas tu oferta + mensajes para WhatsApp'
}, {
  day: 'Día 7',
  action: 'Publicas, contactas y haces ventas'
}];
export function SevenDayPlanSection() {
  return <section className="bg-[#0F0F0F] py-8 px-6 w-full" data-id="element-172">
      <div className="max-w-xl mx-auto" data-id="element-173">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-174">
          <h2 className="text-[22px] font-bold text-white mb-1" data-id="element-175">
            El Plan '7 Días'
          </h2>
          <p className="text-[14px] text-[#AAAAAA]" data-id="element-176">(para mujeres ocupadas)</p>
        </div>

        {/* 7-Day List */}
        <div className="space-y-4" data-id="element-177">
          {planDays.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-178">
              {/* Day Tag */}
              <div className="flex-shrink-0 w-[60px] h-[26px] bg-[#FF4DA6] rounded-md flex items-center justify-center" style={{
            boxShadow: '0 2px 4px rgba(255, 255, 255, 0.4)'
          }} data-id="element-179">
                <span className="text-white text-[13px] font-bold" data-id="element-180">
                  {item.day}
                </span>
              </div>

              {/* Action Text */}
              <p className="text-white text-[14px] leading-snug pt-0.5" data-id="element-181">
                {item.action}
              </p>
            </div>)}
        </div>

        {/* Closing Sentence */}
        <div className="mt-6 text-center" data-id="element-182">
          <p className="text-[16px] font-bold" data-id="element-183">
            <span className="text-white" data-id="element-184">No necesitas perfección. </span>
            <span className="text-[#FF4DA6]" data-id="element-185">Necesitas terminar.</span>
          </p>
        </div>
      </div>
    </section>;
}